import React from 'react';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import SEO from '../components/SEO';
import { Phone, Mail, MapPin, Clock, MessageCircle } from 'lucide-react';
import { companyInfo } from '../data/mock';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { faqs } from '../data/mock';

const Contact = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <SEO 
        title="İletişim"
        description="Duru Halı Yıkama ile iletişime geçin. Bahçeşehir 2.kısım mahallesi, Başakşehir/İstanbul. Tel: 0543 887 08 53"
        keywords="halı yıkama iletişim, bahçeşehir halı yıkama telefon, koltuk yıkama randevu"
        canonical="https://www.bahcesehirduruhaliyikama.com/iletisim"
      />
      {/* Header */}
      <section className="bg-gradient-to-br from-teal-600 to-cyan-600 text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-4">İletişim</h1>
          <p className="text-xl text-teal-50 max-w-3xl mx-auto">
            Sorularınız için bize ulaşın. Size en kısa sürede dönüş yapacağız.
          </p>
        </div>
      </section>

      {/* Contact Info Cards */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-4 gap-6">
            <Card className="p-6 text-center border-2 hover:border-teal-500 transition-colors">
              <div className="w-14 h-14 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Phone className="w-7 h-7 text-teal-600" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2">Telefon</h3>
              <a href={`tel:${companyInfo.phones[0]}`} className="text-teal-600 hover:underline block">
                {companyInfo.phones[0]}
              </a>
              <a href={`tel:${companyInfo.phones[1]}`} className="text-teal-600 hover:underline block">
                {companyInfo.phones[1]}
              </a>
            </Card>

            <Card className="p-6 text-center border-2 hover:border-teal-500 transition-colors">
              <div className="w-14 h-14 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Mail className="w-7 h-7 text-teal-600" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2">E-posta</h3>
              <a href={`mailto:${companyInfo.email}`} className="text-teal-600 hover:underline">
                {companyInfo.email}
              </a>
            </Card>

            <Card className="p-6 text-center border-2 hover:border-teal-500 transition-colors">
              <div className="w-14 h-14 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <MapPin className="w-7 h-7 text-teal-600" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2">Adres</h3>
              <p className="text-gray-600">{companyInfo.address}</p>
            </Card>

            <Card className="p-6 text-center border-2 hover:border-teal-500 transition-colors">
              <div className="w-14 h-14 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Clock className="w-7 h-7 text-teal-600" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2">Çalışma Saatleri</h3>
              <p className="text-gray-600">Pzt-Cmt: 08:00-19:00</p>
              <p className="text-gray-600">Pazar: 09:00-17:00</p>
            </Card>
          </div>
        </div>
      </section>

      {/* Contact Info & Map */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12">
            {/* Map */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Bizi Ziyaret Edin</h2>
              <div className="relative h-96 bg-gray-200 rounded-2xl overflow-hidden shadow-lg mb-8">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d385396.60405578376!2d28.68253899453125!3d41.00537249999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14caa7040068086b%3A0xe1ccfe98bc01b0d!2zxLBzdGFuYnVs!5e0!3m2!1str!2str!4v1642345678901!5m2!1str!2str"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  title="Duru Halı Yıkama Konumu"
                ></iframe>
              </div>
              
              {/* CTA Card */}
              <Card className="p-8 bg-gradient-to-r from-teal-600 to-cyan-600 text-white border-0">
                <h3 className="text-2xl font-bold mb-4">Hemen Bize Ulaşın!</h3>
                <p className="mb-6 text-teal-50">
                  Profesyonel halı ve koltuk yıkama hizmeti için bugün arayın. 
                  Ücretsiz alım-teslim hizmetimizden yararlanın!
                </p>
                <div className="flex flex-col sm:flex-row gap-3">
                  <a href={`tel:${companyInfo.phones[0]}`} className="flex-1">
                    <button className="w-full bg-white text-teal-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors flex items-center justify-center gap-2">
                      <Phone className="w-5 h-5" />
                      Hemen Ara
                    </button>
                  </a>
                  <a 
                    href={`https://wa.me/${companyInfo.whatsapp}?text=${encodeURIComponent('Merhaba, halı yıkama hizmeti hakkında bilgi almak istiyorum.')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-1"
                  >
                    <button className="w-full bg-green-500 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-600 transition-colors flex items-center justify-center gap-2">
                      <MessageCircle className="w-5 h-5" />
                      WhatsApp
                    </button>
                  </a>
                </div>
              </Card>
            </div>

            {/* FAQ Accordion */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Sık Sorulan Sorular</h2>
              <Card className="p-6 border-2 border-teal-100">
                <Accordion type="single" collapsible className="w-full">
                  {faqs.map((faq) => (
                    <AccordionItem key={faq.id} value={`item-${faq.id}`}>
                      <AccordionTrigger className="text-left font-semibold text-gray-900">
                        {faq.question}
                      </AccordionTrigger>
                      <AccordionContent className="text-gray-700">
                        {faq.answer}
                      </AccordionContent>
                    </AccordionItem>
                  ))}
                </Accordion>
              </Card>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
